import * as React from 'react';

type CheckIconProps = {
  className?: string;
};

export const CheckIcon: React.FC<CheckIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="check">
      <path
        id="check_2"
        d="M7.50001 15C7.49917 15 7.49834 15 7.49668 15C7.27418 14.9991 7.0625 14.91 6.90667 14.7517L3.57334 11.3667C3.25001 11.0383 3.25418 10.5108 3.58251 10.1883C3.91084 9.86582 4.43751 9.86915 4.76084 10.1975L7.50501 12.9841L15.245 5.24499C15.5708 4.91915 16.0975 4.91915 16.4233 5.24499C16.7492 5.56999 16.7492 6.09832 16.4233 6.42332L8.09 14.7567C7.93334 14.9125 7.72084 15 7.50001 15Z"
        fill="#0684BC"
      />
    </g>
  </svg>
);
